/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var HeaderTab = (function (_Component) {
	_inherits(HeaderTab, _Component);

	function HeaderTab() {
		_classCallCheck(this, HeaderTab);

		_Component.apply(this, arguments);
	}

	HeaderTab.prototype.render = function render() {
		var _classNames, _classNames2;

		var styles = require('./HeaderTab.css');
		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames));

		var _props = this.props;
		var icon = _props.icon;
		var subhead = _props.subhead;
		var title = _props.title;
		var url = _props.url;

		var tabClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.H1] = !icon, _classNames2[styles['H1--withIcon']] = icon, _classNames2));

		var headerTabContent = _react2['default'].createElement(
			'h1',
			{ className: tabClasses },
			icon && _react2['default'].createElement('i', { className: styles['Icon--' + icon] }),
			title
		);

		var isExternalURL = url && url.substring(0, 4) === 'http';

		return _react2['default'].createElement(
			'header',
			{ className: baseClasses },
			url && isExternalURL && _react2['default'].createElement(
				'a',
				{ href: url },
				' ',
				headerTabContent
			),
			url && !isExternalURL && _react2['default'].createElement(
				_reactRouter.Link,
				{ to: url },
				' ',
				headerTabContent
			),
			!url && headerTabContent,
			subhead ? _react2['default'].createElement(
				'h2',
				{ className: styles.H2 },
				subhead
			) : null
		);
	};

	_createClass(HeaderTab, null, [{
		key: 'propTypes',
		value: {
			className: _react.PropTypes.string,
			icon: _react.PropTypes.string,
			subhead: _react.PropTypes.string,
			title: _react.PropTypes.string.isRequired,
			url: _react.PropTypes.string
		},
		enumerable: true
	}]);

	return HeaderTab;
})(_react.Component);

exports['default'] = HeaderTab;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HeaderTab/HeaderTab.js
 ** module id = 680
 ** module chunks = 0
 **/